// @ts-check
if (!window.AndDaughter) {
  window.AndDaughter = {};
}

window.AndDaughter.productSizeGuide = function () {
  /**
   * @param {HTMLElement[]} buttons that open the modal on click
   */
  const openButtons = document.querySelectorAll("[data-js-open-size-guide]");

  /**
   * @param {HTMLElement} buttons that close the modal on click
   */
  const closeButton = document.querySelector("[data-js-close-size-guide]");

  /**
   * @param {HTMLButtonElement | null} the eleemnt that was focused before the dialog was opened
   */
  let lastFocusedItem = null;

  /**
   * @var {HTMLDialogElement | null}
   * the content/modal of the size guide
   */
  const modal = document.querySelector("#size-guide");

  /**
   * Open the size guide
   *
   * @returns {void}
   */
  const handleOpenButtonClick = (event) => {
    modal?.showModal();

    lastFocusedItem = event.currentTarget;
  };

  /**
   * close the size guide and reset
   *
   * @returns {void}
   */
  const handleClose = () => {
    if (!modal) {
      return;
    }

    modal?.close();

    if (lastFocusedItem) {
      lastFocusedItem.focus();
    }
  };

  /**
   * Add and remove event listeners that will trigger actions on the elements
   *
   * @returns {void}
   */
  const addEventListeners = () => {
    // open
    for (let i = 0; i < openButtons.length; i++) {
      openButtons[i].removeEventListener("click", handleOpenButtonClick);
      openButtons[i].addEventListener("click", handleOpenButtonClick);
    }

    // click/tap close = close
    closeButton?.removeEventListener("click", handleClose);
    closeButton?.addEventListener("click", handleClose);
  };

  /**
   * Scripts/tasks that run when object is first created
   *
   * @returns {void}
   */
  const init = () => {
    if (openButtons.length === 0 || !closeButton) {
      return;
    }

    addEventListeners();
  };

  return {
    init,
  };
};

window.AndDaughter.productSizeGuide().init();
